import React from "react"
import { ConnectionLineComponentProps } from "@xyflow/react"
import { getEdgePath } from "./flow.utils"
import { cn } from "@/lib/utils"

// export default ({ fromX, fromY, toX, toY }) => {
//   const { fromHandle } = useConnection()

//   return (
//     <g>
//       <path
//         fill="none"
//         stroke={"#000"}
//         strokeWidth={1.5}
//         d={`M${fromX},${fromY} C ${fromX} ${toY} ${fromX} ${toY} ${toX},${toY}`}
//       />
//       <circle cx={toX} cy={toY} fill="#fff" r={3} stroke={fromHandle?.id!} strokeWidth={1.5} />
//     </g>
//   )
// }

export default function ConnectionLine(props: ConnectionLineComponentProps) {
  const [path] = getEdgePath({
    sourceX: props.fromX,
    sourceY: props.fromY,
    sourcePosition: props.fromPosition,
    targetX: props.toX,
    targetY: props.toY,
    targetPosition: props.toPosition,
  })

  return (
    <g>
      <defs>
        <marker
          id="arrowhead"
          viewBox="0 0 10 10"
          refX="6"
          refY="5"
          markerWidth="4"
          markerHeight="5"
          orient="auto"
          className={cn(props.fromHandle?.id === "error_handle" ? "fill-[var(--xy-edge-stroke-danger)]" : "fill-[var(--xy-edge-stroke)]")}
        >
          <path d="M 0 0 L 10 5 L 0 10 z" />
        </marker>
      </defs>
      <path
        fill="none"
        className={cn(props.fromHandle?.id === "error_handle" ? "stroke-[var(--xy-edge-stroke-danger)]" : "stroke-[var(--xy-edge-stroke)]")}
        strokeWidth={4}
        // className="animated"
        // d={`M${sourceX},${sourceY} C ${sourceX} ${targetY} ${sourceX} ${targetY} ${targetX},${targetY}`}
        // d={`M${props.fromX},${props.fromY} C ${props.fromX} ${props.toY} ${props.fromX} ${props.toY} ${props.toX},${props.toY}`}
        d={path}
        markerEnd="url(#arrowhead)"
      />
      {/* <circle cx={targetX} cy={targetY} fill="var(--edge)" r={5} stroke="var(--edge)" strokeWidth={5} /> */}
    </g>
  )
}
